import { useEffect, useState } from "react";
import { FaUser } from "react-icons/fa6";
import { getAuthor, urlAPI } from "../../services/api.services";
import { Link, useParams } from "react-router-dom/cjs/react-router-dom.min";

export const Author = () => {
  const { id } = useParams();
  const parsedId = parseInt(id);

  const [data, setData] = useState([]);

  useEffect(() => {
    async function fetchData() {
      await getAuthor(parsedId, (data) => {
        setData(data?.data);
      });
    }
    fetchData();
  }, [parsedId]);

  const renderTruncatedHTML = (htmlString, maxLength) => {
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = htmlString;

    let textContent = tempDiv.textContent || tempDiv.innerText || "";
    if (textContent.length > maxLength) {
      textContent = textContent.substr(0, maxLength) + "...";
    }
    tempDiv.innerHTML = textContent;
    return tempDiv.innerHTML;
  };

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 5;

  const totalPages = Math.ceil(data?.blogs?.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const paginatedBlogs = data?.blogs?.slice(
    startIndex,
    startIndex + itemsPerPage
  );

  const sortedBlog = paginatedBlogs
    ?.slice()
    .sort((a, b) => new Date(b.created_at) - new Date(a.created_at));

  const handlePageChange = (page) => {
    setCurrentPage(page);
    window.scrollTo({ top: 0, behavior: "smooth" }); // Optional: Scroll to top
  };

  return (
    <div className="w-[100vw]">
      <section className="max-w-screen-lg mx-auto px-4 flex flex-col md:flex-row items-center justify-between gap-6 py-10 md:py-20">
        {/* Info Author */}
        <div className="flex items-center gap-4 text-center md:text-left">
          {/* Icon/User Image */}
          <div className="w-24 h-24 rounded-full bg-gray-400 flex items-center justify-center overflow-hidden">
            {/* <p>
              <FaUser />
            </p> */}
            {data?.author?.image_url ? (
              <img
                src={urlAPI + data?.author?.image_url}
                alt="Author"
                className="w-full h-full object-cover"
              />
            ) : (
              // <img
              //   src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQgP800jb2DE6yqLBxVbe8SJINe29Y4ruA6hA&s"
              //   alt="Author"
              //   className="w-full h-full object-cover"
              // />

              <FaUser className="text-white text-6xl" />
            )}
          </div>

          {/* Name & Description */}
          <div className="flex flex-col gap-2">
            <div>
              <h2 className="text-lg font-semibold text-gray-800">
                {data?.author?.name}
              </h2>
              {/* <div className="flex items-center gap-2">
                <p>{data?.author?.email}</p>
                <p>|</p>
                <p>Role : {data?.author?.type}</p>
              </div> */}
            </div>
            <div
              className=" text-gray-600 text-sm lg:text-base max-w-md"
              dangerouslySetInnerHTML={{
                __html:
                  data?.author?.description !== null
                    ? data?.author?.description
                    : "-",
              }}
            />
          </div>
        </div>
      </section>

      {/* Garis Horizontal */}
      <hr className="border-t border-gray-200 my-4 w-full" />

      {/* blog */}
      <div>
        {data?.blogs?.length >= 1 && (
          <>
            <section id="project-detail" className="py-10 lg:py-20">
              <div className="max-w-80 md:max-w-screen-sm lg:max-w-screen-xl mx-auto">
                <h1 className="text-4xl md:text-6xl font-medium text-center mb-5 text-birtua tracking-wider">
                  All Articles
                </h1>
                <div>
                  {sortedBlog.map((item, index) => (
                    <div
                      key={index}
                      className={`lg:flex md:pt-28 ${
                        index % 2 === 0 ? "" : "md:flex-row-reverse"
                      }`}
                    >
                      <div className="pt-10 md:pt-0 md:w-5/6 lg:w-3/6 m-auto">
                        <img
                          className="md:img-layout2 mx-auto lg:h-96 w-full object-cover rounded-xl"
                          src={urlAPI + item.image_url}
                          alt=""
                        />
                      </div>
                      <div
                        className={`m-auto px-5 text-center lg:text-left md:w-5/6 lg:w-3/6 my-auto pt-5 lg:pt-0 bg-clip-text text-transparent bg-gradient-to-r from-[#0E46A3] to-[#031736]  ${
                          index % 2 === 0
                            ? ""
                            : "lg:text-right md:from-[#031736] md:to-[#0E46A3]"
                        }`}
                      >
                        <h1 className="uppercase tracking-widest text-xl md:text-4xl font-bold">
                          {item.title}
                        </h1>
                        <div
                          className="py-5 text-black"
                          dangerouslySetInnerHTML={{
                            __html: renderTruncatedHTML(item.description, 100),
                          }}
                        />
                        <div className="pb-3 text-birmud">
                          <a
                            href={`/blog/${item.id}`}
                            className="uppercase underline underline-offset-4 hover:tracking-wider"
                          >
                            read more
                          </a>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
              <div className="flex justify-center gap-2 mt-10 flex-wrap">
                {Array.from({ length: totalPages }, (_, i) => i + 1)
                  .filter((page) => {
                    if (totalPages <= 4) return true;
                    if (currentPage <= 2) return page <= 3;
                    if (currentPage >= totalPages - 1)
                      return page >= totalPages - 2;
                    return Math.abs(page - currentPage) <= 1;
                  })
                  .map((page) => (
                    <button
                      key={page}
                      onClick={() => handlePageChange(page)}
                      className={`px-4 py-2 border rounded-md ${
                        currentPage === page
                          ? "bg-[#0E46A3] text-white"
                          : "bg-white text-[#0E46A3] border-[#0E46A3]"
                      } hover:shadow-lg transition`}
                    >
                      {page}
                    </button>
                  ))}

                {/* Tampilkan tombol "..." jika masih ada halaman lanjut */}
                {totalPages > 4 && currentPage < totalPages - 1 && (
                  <button
                    onClick={() => handlePageChange(currentPage + 1)}
                    className="px-4 py-2 border rounded-md bg-white text-[#0E46A3] border-[#0E46A3] hover:shadow-lg transition"
                  >
                    ...
                  </button>
                )}
              </div>
            </section>
          </>
        )}
      </div>
    </div>
  );
};
